import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_FUND_ACCOUNT_UNLINK_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_FUND_ACCOUNT_UNLINK_API_ID';

const apiCall = createApiCall(
  FETCH_INVESTCORE_FUND_ACCOUNT_UNLINK_API_ID,
  ({ id }: { id: string }) => ({
    endpoint: `/api/admin/fund-accounts/${id}/unlink`,
    method: 'POST',
    notify: true,
  })
);

export default apiCall;
